import React from 'react';
import Role from 'views/config//roles/role/Role';
import RolesList from 'views/config//roles/RolesList/RolesList';
import SystemAdminList from 'views/config/SystemAdministrators/SystemAdminList';
import UsersManagement from 'views/config/userManagement/UsersManagement';
import Workgroups from 'views/config/workgroups/Workgroups';
import ErrorPage from 'views/ErrorPage';
import { MapPage } from 'views/map/MapPage';
import NoFeaturePermissionsPage from 'views/NoFeaturePermissionsPage';
import NoPermissionsPage from 'views/NoPermissionsPage';
import NotFoundPage from 'views/NotFoundPage';
import SignoutPage from 'views/SignoutPage';
import SupportPage from 'views/SupportPage';
import UnauthenticatedPage from 'views/UnauthenticatedPage';
import { configRoutePath, routePath } from './routePaths';
import { AssetList } from 'views/assets/AssetList/AssetList';
import { AssetForm } from 'views/assets/AssetForm/AssetForm';
import { RecentUserList } from 'views/users/RecentUserList';
import { AssetManagement } from 'views/assets/AssetManagment/AssetManagement';
import { BeaconManagement } from 'views/beacons/BeaconManagement';
import { BeaconForm } from 'views/beacons/components/BeaconForm/BeaconForm';

export type routesType = {
  url: string;
  component?: React.FC;
  title?: string;
  isConfig?: boolean;
  hideNavigation?: boolean;
  redirectTo?: string;
  navCollapsedDefault?: boolean;
  excludeHeader?: boolean;
};

const routes: routesType[] = [
  {
    url: '/',
    redirectTo: '/map',
    component: MapPage,
    navCollapsedDefault: true,
  },
  {
    url: routePath.map,
    title: 'Map View',
    component: MapPage,
    navCollapsedDefault: true,
  },
  {
    url: routePath.assetList,
    title: 'Asset List',
    component: AssetList,
    excludeHeader: true
  },
  {
    url: routePath.assetManagement,
    title: 'Asset Management',
    component: AssetManagement,
  },
  {
    url: routePath.beaconManagement,
    title: 'Beacon Management',
    component: BeaconManagement,
  },
  {
    url: routePath.beaconsList,
    title: 'Beacon Management',
    component: BeaconManagement,
  },
  {
    url: routePath.editAsset,
    title: 'Edit Asset',
    component: AssetForm,
  },
  {
    url: routePath.editBeacon,
    title: 'Edit Beacon',
    component: BeaconForm,
  },
  {
    url: routePath.recentUsers,
    title: 'Users: Current Locations',
    component: RecentUserList,
  },
  {
    url: configRoutePath.systemAdminList,
    title: 'System Administrators',
    component: SystemAdminList,
    isConfig: true
  },
  {
    url: configRoutePath.userManagement,
    title: 'User Management',
    component: UsersManagement,
    navCollapsedDefault: true,
    isConfig: true
  },
  {
    url: configRoutePath.Workgroups,
    title: 'Workgroups',
    component: Workgroups,
    isConfig: true
  },
  {
    url: configRoutePath.listRoles,
    title: 'View and Manage Roles',
    component: RolesList,
    isConfig: true
  },
  {
    url: `${configRoutePath.listRoles}/:workgroupId`,
    title: 'View and Manage Roles',
    component: RolesList,
    isConfig: true
  },
  {
    url: configRoutePath.addRole,
    title: 'Create Role',
    component: Role,
    isConfig: true
  },
  {
    url: `${configRoutePath.editRole}/:roleId`,
    title: 'Edit Role',
    component: Role,
    isConfig: true
  },
  {
    url: 'unauthenticated',
    title: 'Not Authenticated',
    hideNavigation: true,
    component: UnauthenticatedPage,
  },
  {
    url: routePath.unauthorised,
    title: 'You do not have Permission',
    hideNavigation: true,
    component: NoPermissionsPage,
  },
  {
    url: 'no-feature-permission',
    hideNavigation: true,
    component: NoFeaturePermissionsPage,
  },

  {
    url: 'signout',
    hideNavigation: true,
    component: SignoutPage,
  },
  {
    url: 'support',
    title: 'Support',
    component: SupportPage,
  },
  {
    url: 'error',
    title: 'Error',
    hideNavigation: true,
    component: ErrorPage,
  },
  {
    url: 'authentication/callback',
    title: 'Authentication Successful',
    hideNavigation: true,
    redirectTo: routePath.map
  },
  {
    url: '*',
    title: 'Not Found',
    hideNavigation: true,
    component: NotFoundPage,
  },
];

export default routes;
